import GlobalConstants from "@constants";

import { DateTime } from "luxon";

interface Contract {
  endDate: string | Date;
  contractCategory?: number;
  serviceLevelAgreementID?: number;
  contractType?: number;
  cloud?: string;
  userDefinedFieldsJson?: string;
}

export const expiredContract = (contract: Contract) => {
  const today = DateTime.now().setZone("utc");
  return today >= DateTime.fromJSDate(new Date(contract.endDate));
};

export const determineContractType = (contract: Contract): string => {
  switch (true) {
    case contract.contractCategory ===
      GlobalConstants.contractCategory.flexibleServiceAgreement:
      return GlobalConstants.contractDetailsType.fsa;
    case contract.serviceLevelAgreementID ===
      GlobalConstants.serviceLevelAgreement.agileCloudEngineering:
      return GlobalConstants.contractDetailsType.ace;
    case contract.contractType ===
      GlobalConstants.contractType.recurringService &&
      contract.contractCategory ===
        GlobalConstants.contractCategory.managedService:
      return GlobalConstants.contractDetailsType.managedRecurringService;
    case contract.contractType ===
      GlobalConstants.contractType.recurringService:
      return GlobalConstants.contractDetailsType.recurringService;
    default:
      return GlobalConstants.contractDetailsType.generic;
  }
};

export const hasAzureCloudContracts = (cloudContracts: Contract[] | null | undefined) => {
  return (
    cloudContracts &&
    cloudContracts.filter(
      (c) =>
        (c.cloud === "Azure" || c.cloud === "Azure CSP") &&
        c.userDefinedFieldsJson &&
        c.userDefinedFieldsJson !== "[]"
    ).length > 0
  );
};

export const hasAwsCloudContracts = (cloudContracts: Contract[] | null | undefined) => {
  return (
    cloudContracts &&
    cloudContracts.filter(
      (c) =>
        c.cloud === "AWS" &&
        c.userDefinedFieldsJson &&
        c.userDefinedFieldsJson !== "[]"
    ).length > 0
  );
};

export const hasOffice365CloudContracts = (cloudContracts: Contract[] | null | undefined) => {
  return (
    cloudContracts &&
    cloudContracts.filter(
      (c) =>
        (c.cloud === "Office 365 CSP" || c.cloud === "Office 365") &&
        c.userDefinedFieldsJson &&
        c.userDefinedFieldsJson !== "[]"
    ).length > 0
  );
};

interface TeamContracts {
  cloudContracts?: Array<{ contractCategory: number; serviceLevelAgreementID: number }>;
}

export const hasGCPCloudContracts = (teamContracts: TeamContracts | null | undefined, cloudContracts: Contract[] | null | undefined) => {
  const hasGcpCloudContracts =
    cloudContracts &&
    cloudContracts.filter(
      (c) =>
        (c.cloud === "GCP" || c.cloud === "GCP Project") &&
        c.userDefinedFieldsJson &&
        c.userDefinedFieldsJson !== "[]"
    ).length > 0;
  const hasGcpTeamCloudContracts =
    teamContracts &&
    teamContracts.cloudContracts &&
    teamContracts.cloudContracts.length > 0 &&
    teamContracts.cloudContracts.filter(
      (tc) =>
        tc.contractCategory === GlobalConstants.contractCategory.gcp &&
        tc.serviceLevelAgreementID === GlobalConstants.serviceLevelAgreement.gcp
    ).length > 0;

  return !!(hasGcpCloudContracts || hasGcpTeamCloudContracts);
};

export const shouldContractHaveDetails = (contract: Contract): boolean => {
  return (
    determineContractType(contract) !==
    GlobalConstants.contractDetailsType.generic
  );
};
